// extracted by mini-css-extract-plugin
export default {"question":"QuestionsForm_question__B5jkl","gridRow":"QuestionsForm_gridRow__a1X3n"};